module.exports = __webpack_public_path__ + "static/revenant-4645ed5fe4024733495462ef8beb172a.jpeg";